import React, { useEffect, useState } from 'react';
import { loginuser } from '../../services/AuthService';

export default function Loginuser() {
  const [result, setResult] = useState('Loading...');
  useEffect(() => {
    const login = async () => {
      const data = {
        i_token: localStorage.getItem('i_token'),
        i_user: localStorage.getItem('i_user'),
      };
      localStorage.removeItem('i_token');
      localStorage.removeItem('i_user');
      try {
        await loginuser(data);
        window.location = '/';
      } catch (error) {
        setResult('Error: user not found');
        console.error(error);
        return;
      }
    };

    login();
  }, []);

  return <>{result}</>;
}
